import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

const SpecialRoute = ({ component: Component, ...restProps }) => (
  <Route {...restProps} render={(props) => <Component {...props} />} />
);

SpecialRoute.propTypes = {
  component: PropTypes.func.isRequired,
};

export default SpecialRoute;
